import { render, staticRenderFns } from "./KV2.vue?vue&type=template&id=a82da540&scoped=true&"
import script from "./KV2.vue?vue&type=script&lang=ts&"
export * from "./KV2.vue?vue&type=script&lang=ts&"
import style0 from "./KV2.vue?vue&type=style&index=0&id=a82da540&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82da540",
  null
  
)

export default component.exports